import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokImageComponent } from '../../app/content/modules/storyblok/components/storyblok-image/storyblok-image.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

const meta: Meta<StoryblokImageComponent> = {
  title: 'Storyblok/Image',
  component: StoryblokImageComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok image block. Renders an optimized image with alignment options and optional external URL.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokImageComponent>;

export const Default: Story = {
  args: {
    asset: { id: 'sb-asset-1', filename: 'https://a.storyblok.com/f/106593/5459x1241/65f115b636/supervin_hvidorange_highres.png', alt: 'Wine vineyard' },
    _uid: 'sb-img-1',
    component: 'image',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image')).toBeTruthy();
  },
};

export const CenterAligned: Story = {
  args: {
    asset: { id: 'sb-asset-2', filename: 'https://a.storyblok.com/f/106593/100x100/cc535ac665/bla-drue-tegning.jpg', alt: 'Centered image' },
    horizontal_alignment: 'center',
    _uid: 'sb-img-2',
    component: 'image',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image')).toBeTruthy();
  },
};

export const RightAligned: Story = {
  args: {
    asset: { id: 'sb-asset-3', filename: 'https://a.storyblok.com/f/106593/100x100/f35c5f3002/gron-drue-tegning.jpg', alt: 'Right aligned' },
    horizontal_alignment: 'right',
    _uid: 'sb-img-3',
    component: 'image',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image')).toBeTruthy();
  },
};

export const WithExternalUrl: Story = {
  args: {
    asset: { id: 'sb-asset-4', filename: 'https://a.storyblok.com/f/106593/100x100/5f307117b7/begge-druer-tegning.jpg', alt: 'Clickable image' },
    external_url: 'https://supervin.dk',
    _uid: 'sb-img-4',
    component: 'image',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image')).toBeTruthy();
  },
};
